"use client";
import { SHARE_QUERY_PARAM as t } from "../providers/conversation-provider.js";
const i = () => {
  const e = typeof window > "u" ? new URL("") : new URL(window.location.href), n = new URLSearchParams(e.search);
  if (n.has(t)) {
    n.delete(t);
    const r = n.toString(), o = r ? `${e.origin}${e.pathname}?${r}` : `${e.origin}${e.pathname}`;
    typeof window < "u" && window.history.pushState({}, "", o);
  }
};
export {
  i as resetQueryParams
};
